import BaseAPIService from 'src/services/base/base-api-service';

import SamsungOrderInvoiceModel from 'src/model/samsungOrderInvoice.model';
import DateRangeModel from 'src/model/dateRange.model';
import * as React from 'react';
export interface IFiltersSamsungOrderInvoice {
  dateRange: DateRangeModel;
  // sort: { type: sortType; order: 'asc' | 'desc' };
  // status: statusType;
}

export interface IPaginationSamsungOrderInvoice {
  page: number;
  size?: number;
}

class SamsungOrderInvoiceService extends BaseAPIService<
  SamsungOrderInvoiceModel
> {
  private endpoint: string = 'accountapp/v1/samsung-order/details';
  private exportEndpoint: string = 'accountapp/v1/samsung-order/export';

  constructor() {
    super(SamsungOrderInvoiceModel);
  }

  private buildOrderInvoicesParams = (
    filters: any,
    pagination: IPaginationSamsungOrderInvoice
  ) => {
    const requestData: any = {
      // dateFrom:
      //   filters.dateRange && filters.dateRange.start
      //     ? filters.dateRange.start.format('YYYY-MM-DD')
      //     : undefined,
      // dateTo:
      //   filters.dateRange && filters.dateRange.end
      //     ? filters.dateRange.end.format('YYYY-MM-DD')
      //     : undefined,
    };
    //   sort:
    //     filters.sort && filters.sort.type && filters.sort.order
    //       ? `${filters.sort.type},${filters.sort.order}`
    //       : 'invoiceDate,desc',
    //   status: filters.status
    Object.keys(filters).forEach(key =>
      !filters[key] ? delete filters[key] : ''
    );
    const parameters: any = {
      data: filters,
      method: 'POST',
      baseURL: this.baseURL,
      url: `${this.endpoint}`,
      params: pagination
    };
    return parameters;
  };

  private buildExportOrderInvoicesParams = (filters: any) => {
    const requestData: any = {};
    Object.keys(filters).forEach(key =>
      !filters[key] ? delete filters[key] : ''
    );
    const parameters: any = {
      data: filters,
      method: 'POST',
      baseURL: this.baseURL,
      url: `${this.exportEndpoint}`,
      responseType: 'blob'
    };
    return parameters;
  };

  private setLocalIndex(ordersInvoices: SamsungOrderInvoiceModel[]) {
    return ordersInvoices.map((orderInvoice, idx) => {
      return {
        ...orderInvoice,
        idx: `${orderInvoice.orderNumber}`
      };
      // idx: `${orderInvoice.orderNumber}`//&${orderInvoice.orderNumber}`
    });
  }

  public getOrdersAndInvoices(
    filters: any,
    pagination: IPaginationSamsungOrderInvoice
  ) {
    const params = this.buildOrderInvoicesParams(filters, pagination);

    return new Promise((resolve, reject) => {
      this.doRequest(params)
        .then((response: any) => {
          const dataList = this.setLocalIndex(response.data.data);
          const result = { ...response, dataList };
          if (result.content) {
            resolve(result);
          } else {
            const newResponse = { ...result };
            newResponse.content = [];
            resolve(newResponse);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public exportOrdersAndInvoices(filters: any) {
    const params = this.buildExportOrderInvoicesParams(filters);
    return new Promise((resolve, reject) => {
      this.doRequest(params)
        .then((response: any) => {
          if (response) {
            resolve(response);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public transformSamsungResult = (
    samsungOrderInvoicesResponse: any[]
  ): any[][] => {
    const samsungRows = samsungOrderInvoicesResponse || [];
    return samsungRows.map((samsungOrder: any) => {
      const samsungRow: any[] = [];
      const trackingLink = React.createElement(
        'a',
        {href: samsungOrder['trackingLink'], target: "_blank"},
        samsungOrder['trackingNumber']
      );     
      
      samsungRow.push(samsungOrder['ticket']);
      samsungRow.push(samsungOrder['customerCode']);
      samsungRow.push(samsungOrder['palletRegNumber']);
      samsungRow.push(samsungOrder['orderNumber']);
      samsungRow.push(samsungOrder['orderReference']);
      samsungRow.push(samsungOrder['orderDate']);
      samsungRow.push(samsungOrder['invoiceDate']);
      samsungRow.push(samsungOrder['orderStatusDescription']);
      samsungRow.push(samsungOrder['productCodeS2']);
      samsungRow.push(samsungOrder['description']);
      samsungRow.push(samsungOrder['orderQuantity']);
      samsungRow.push(samsungOrder['price']);
      samsungRow.push(samsungOrder['invoiceQuantity']);
      samsungRow.push(samsungOrder['deliveryDate']);
      samsungRow.push(trackingLink);
      samsungRow.push(samsungOrder['invoiceNumber']);
      samsungRow.push(samsungOrder['warehouseCity']);
      samsungRow.push(samsungOrder['motDescription']);
      samsungRow.push(samsungOrder['shipToName']);
      samsungRow.push(samsungOrder['shipToCity']);
      samsungRow.push(samsungOrder['serialNumber']);
      samsungRow.push(samsungOrder['coreNumber']);
      return samsungRow;
    });
  };

  public getPageInformation = (response: any): any => {
    return {
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalElements: response.totalElements,
      totalPages: response.totalPages
    };
  };
}

const samsungOrderInvoiceServiceInstance = new SamsungOrderInvoiceService();
Object.freeze(samsungOrderInvoiceServiceInstance);

export default samsungOrderInvoiceServiceInstance;
